import React from 'react'
import PropTypes from 'prop-types'
import { TOPBAR_SIZE, IMG } from '../../themes'
import StyleTopbar, { ArrowRight } from './style'

const Topbar = (props) => {
  const {
    addonComponent: AddonComponent,
    height,
    isTextStartBig,
    onClickBackToBeforePage,
    textBreadcrumbStart,
    textBreadcrumbEnd,
    textCenter,
  } = props

  return (
    <StyleTopbar
      textEnd={textBreadcrumbEnd}
      textCenter={textCenter}
      height={height}
      isTextStartBig={isTextStartBig}
    >
      <div className='top-bar__left'>

        {Array.isArray(textBreadcrumbStart) ? (
          textBreadcrumbStart.map((crumb, idx) => (
            <React.Fragment key={idx}>
              <span className='text-breadcrumb__start' onClick={crumb.onClick}>
                {crumb.title}
              </span>
              {idx < textBreadcrumbStart.length - 1 && <span className='text-arrow'>/</span>}
            </React.Fragment>
          ))
        ) : textBreadcrumbStart && typeof textBreadcrumbStart === 'string' && textBreadcrumbStart.includes(' / ') ? (
          <React.Fragment>
            <span className='text-breadcrumb__start--static'>
              {textBreadcrumbStart.split(' / ')[0]}
            </span>
            <span className='text-arrow'>/</span>
            <span className='text-breadcrumb__start' onClick={onClickBackToBeforePage}>
              {textBreadcrumbStart.split(' / ')[1]}
            </span>
          </React.Fragment>
        ) : (
          <span className='text-breadcrumb__start' onClick={onClickBackToBeforePage}>
            {textBreadcrumbStart}
          </span>
        )}

        {textBreadcrumbEnd && (
          <React.Fragment>

            <span className='text-arrow'>
              /
            </span>

            <span className='text-breadcrumb__end'>
              {textBreadcrumbEnd}
            </span>
          </React.Fragment>
        )}

        {AddonComponent && AddonComponent()}
      </div>

      {textCenter && (
        <div className='top-bar__center'>
          {textCenter}
        </div>
      )}

      {/* For LOGO only */}
      <a
        className='top-bar__right'
        href={process.env.REACT_APP_VICH_WEBSITE_WEB_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img alt='logo' src={IMG['vich_logo_black.png']} width='80px' height='28px' style={{ objectFit: 'contain' }} />
      </a>
    </StyleTopbar>
  )
}

Topbar.defaultProps = {
  addonComponent: null,
  height: TOPBAR_SIZE.LV_1,
  isTextStartBig: false,
  onClickBackToBeforePage: () => { },
  textBreadcrumbStart: '',
  textBreadcrumbEnd: '',
  textCenter: '',
}

Topbar.propsTypes = {
  addonComponent: PropTypes.node,
  height: PropTypes.string,
  isTextStartBig: PropTypes.bool,
  onClickBackToBeforePage: PropTypes.func,
  textBreadcrumbStart: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  textBreadcrumbEnd: PropTypes.string,
  textCenter: PropTypes.string,
}

export default Topbar
